import { APPLICATION } from "constants/app.mjs"
import { useCurrentPricingInfo as useCurrentTokenTerminalPricingInfo } from "context/SocketContext"
import { type PriceDataValue } from "data/socket"
import { useCurrentBloombergPricingInfo } from "modules/bloomberg/hooks"

export const useProjectPriceV3 = (
  slug?: string,
  bbTicker?: string | null
): PriceDataValue | null => {
  const ttPricing = useCurrentTokenTerminalPricingInfo(slug)
  const bloombergPricing = useCurrentBloombergPricingInfo(bbTicker)

  if (APPLICATION === "bloomberg" && bloombergPricing) {
    return bloombergPricing
  }

  if (ttPricing) {
    return ttPricing
  }

  return null
}
